import React, { useEffect, useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import Select from "react-select";
import { useMutation, useQuery } from "@apollo/client";
import { CREATE_BANK_DETAILS } from "../graphql/Mutation/Signin.js";
import { toast } from "react-toastify";
import SpinLoader from "../components/SpinLoader.js";
import { GET_BANK_DETAILS_BY_ID } from "../graphql/Query/SellerPruff.js";
import Header from "../Header/Header.js";
import SideBar from "../OrderPage/SideBar.js";
import SettingsHeader from "../OrderPage/SettingsHeader.js";
import { GiSettingsKnobs } from "react-icons/gi";
import axios from "axios";

const SellerPrufDetails = () => {
    const [createBankDetails, { loading }] = useMutation(CREATE_BANK_DETAILS)
    const { data, refetch } = useQuery(GET_BANK_DETAILS_BY_ID, {
        fetchPolicy: "cache-and-network"
    })
    const [initialValues, setInitialValues] = useState({
        bankHolderName: '',
        ifscCode: '',
        accountNumber: '',
        bankName: '',
        branchName: '',
        city: '',
        state: '',
        accountType: '',
        gstNumber: '',
    });

    // Update initial values when query data is available
    useEffect(() => {
        if (data?.getBankDetailsById) {
            setInitialValues({
                bankHolderName: data?.getBankDetailsById?.bankHolderName || '',
                ifscCode: data?.getBankDetailsById?.ifscCode || '',
                accountNumber: data?.getBankDetailsById?.accountNumber || '',
                bankName: data?.getBankDetailsById?.bankName || '',
                branchName: data?.getBankDetailsById?.branch || '',
                city: data?.getBankDetailsById?.city || '',
                state: data?.getBankDetailsById?.state || '',
                accountType: accountTypeOptions.find(option => option.value === data?.getBankDetailsById?.accountType) || null,  // Convert to object                gstNumber: data?.getBankDetailsById?.gstNumber || '',
                // gstNumber: data?.getBankDetailsById?.gstNumber || '',
            });
        }
    }, [data]);


    const [ifscError, setIfscError] = useState("");



    const validationSchema = Yup.object().shape({
        // gstNumber: Yup.string()
        //     .required("GST Number is required")
        //     .matches(/^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/, "Enter a valid GST Number"),

        // gst: Yup.mixed().required("GST upload is required"),
        // cancelledCheck: Yup.mixed().required("Cancelled Check upload is required"),
        // panCard: Yup.mixed().required("PAN Card upload is required"),
        // aadhaarCard: Yup.mixed().required("Aadhaar Card upload is required"),
        bankHolderName: Yup.string().required("Bank Holder Name is required"),
        ifscCode: Yup.string().required("IFSC Code is required"),
        // .matches(/^[A-Z]{4}0[A-Z0-9]{6}$/, "Invalid IFSC Code"),
        accountNumber: Yup.string()
            .required("Account Number is required")
            .matches(/^\d{9,18}$/, "Account Number must be between 9 and 18 digits"),
        bankName: Yup.string().nullable().required("Bank Name is required"),
        accountType: Yup.object()
            .nullable()
            .required("Account Type is required"),
    });




    const onSubmit = async (values, { resetForm }) => {
        try {
            const data = await createBankDetails({
                variables: {
                    input: {
                        bankHolderName: values?.bankHolderName,
                        ifscCode: values?.ifscCode,
                        accountNumber: values?.accountNumber,
                        bankName: values?.bankName,
                        accountType: values?.accountType?.value,
                        gstNumber: values?.gstNumber,
                        branch: values?.branchName,
                        state: values?.state,
                        city: values?.city,
                        // gstImage:,
                        // cancelledCheckImageL:,
                        // panCardImage:,
                        // aadhaarCardImage:,
                    },
                },
            });
            if (data?.data?.createBankDetails?.status) {
                toast.success(data?.data?.createBankDetails?.message);
                refetch()
                resetForm()
            }
        } catch (err) {
            toast.error(err.message);
        }

    };


    const accountTypeOptions = [
        { value: "Saving", label: "Saving" },
        { value: "Current", label: "Current" },
    ];
    const fetchBankName = async (ifsc, setFieldValue) => {
        setIfscError(""); // Reset error message
        try {
            const response = await axios.get(`https://ifsc.razorpay.com/${ifsc}`);
            const data = response?.data;

            setFieldValue("bankName", data?.BANK);
            setFieldValue("branchName", data?.BRANCH);
            setFieldValue("state", data?.STATE);
            setFieldValue("city", data?.CITY);
        } catch (error) {
            setFieldValue("bankName", "");
            setFieldValue("branchName", "");
            setFieldValue("state", "");
            setFieldValue("city", "");
        }
    };




    return (
        <>

            {/* Header */}
            <Header />

            <div className="flex min-h-screen bg-slate-100 overflow-hidden">
                {/* Sidebar */}

                <SideBar
                />

                {/* Main Content */}
                <div className="flex-1 space-y-6 px-0 py-6 md:p-6 overflow-x-hidden ml-16">
                    <SettingsHeader />
                    <div className="grid grid-cols-12 md:space-x-7 min-h-screen">
                        {/* Sidebar (Left Panel) */}
                        <div className="col-span-3 bg-white p-6 rounded-md hidden md:block">
                            {/* Content for sidebar */}
                            <h1 className='font-semibold text-xl mb-6'>Settings</h1>
                            <p>Take your shipping experience a notch higher with us by regulating your panel settings as per your convenience and specific business requirements. From importing orders to managing labels and all other account settings, get everything at the tap of your finger for an uninterrupted experience.</p>
                            <GiSettingsKnobs className="h-96 w-96 text-slate-100" />
                        </div>

                        {/* Main Content (Right Panel) */}
                        <div className="col-span-12 md:col-span-9 rounded-md bg-white p-4">
                            <p className="px-4 py-2 mb-7 border border-sky-100 bg-sky-50">On this page, you can fill your bank details for COD remittance.</p>
                            {/* Main content goes here */}
                            {/* <div className="max-w-4xl mx-auto mt-10 p-6 bg-white rounded-lg shadow-md"> */}
                            {/* <h2 className="text-2xl font-bold mb-6">Upload Your Documents</h2> */}

                            <Formik
                                enableReinitialize
                                initialValues={initialValues}
                                validationSchema={validationSchema}
                                onSubmit={onSubmit}
                            >
                                {({ setFieldValue, values }) => (
                                    <Form className="space-y-6">
                                        <div className="grid grid-cols-1 md:grid-cols-2 text-sm lg:grid-cols-2 gap-6">
                                            {/* Account Number */}
                                            <div>
                                                <label className="block text-sm font-medium mb-2">Account No. <span className="text-red-400">*</span></label>
                                                <Field
                                                    type="text"
                                                    disabled={!!initialValues?.accountNumber}
                                                    name="accountNumber"
                                                    placeholder="Enter Account Number"
                                                    className="w-full px-4 py-2 border-b border-dashed border-gray-300  rounded-md"
                                                    onChange={(e) => {
                                                        setFieldValue("accountNumber", e.target.value);
                                                    }}
                                                />
                                                <ErrorMessage name="accountNumber" component="div" className="text-red-500 text-sm mt-2" />
                                            </div>

                                            {/* Bank Holder Name */}
                                            <div>
                                                <label className="block text-sm font-medium mb-2">Account Holder Name <span className="text-red-400">*</span></label>
                                                <Field
                                                    type="text"
                                                    name="bankHolderName"
                                                    disabled={!!initialValues?.bankHolderName}
                                                    placeholder="Enter Bank Holder Name"
                                                    className="w-full px-4 py-2 border-b border-dashed border-gray-300  rounded-md"
                                                    onChange={(e) => {
                                                        setFieldValue("bankHolderName", e.target.value);
                                                    }}

                                                />
                                                <ErrorMessage name="bankHolderName" component="div" className="text-red-500 text-sm mt-2" />
                                            </div>

                                            {/* IFSC Code */}
                                            <div>
                                                <label className="block text-sm font-medium mb-2">IFSC Code <span className="text-red-400">*</span></label>
                                                <Field
                                                    type="text"
                                                    name="ifscCode"
                                                    disabled={!!initialValues?.ifscCode}
                                                    placeholder="Enter IFSC Code"
                                                    className="w-full px-4 py-2 uppercase border-b border-dashed border-gray-300  rounded-md"
                                                    onChange={(e) => {
                                                        setFieldValue("ifscCode", e.target.value);
                                                        fetchBankName(e.target.value, setFieldValue);
                                                    }}
                                                />
                                                <ErrorMessage name="ifscCode" component="div" className="text-red-500 text-sm mt-2" />
                                                {ifscError && <div className="text-red-500 text-sm mt-2">{ifscError}</div>}
                                            </div>



                                            {/* Bank Name */}
                                            <div>
                                                <label className="block text-sm font-medium mb-2">Bank Name <span className="text-red-400">*</span></label>
                                                <Field
                                                    type="text"
                                                    name="bankName"
                                                    disabled={!!initialValues?.bankName}
                                                    placeholder="Bank Name"
                                                    className="w-full px-4 py-2 border-b border-dashed border-gray-300  rounded-md bg-slate-100"
                                                    onChange={(e) => {
                                                        setFieldValue("bankName", e.target.value);
                                                    }}
                                                // readOnly
                                                />
                                                <ErrorMessage name="bankName" component="div" className="text-red-500 text-sm mt-2" />
                                            </div>
                                            {/* Branch Name */}
                                            <div>
                                                <label className="block text-sm font-medium mb-2">Branch Name <span className="text-red-400">*</span></label>
                                                <Field
                                                    type="text"
                                                    name="branchName"
                                                    disabled={!!initialValues?.branchName}
                                                    placeholder="Branch Name"
                                                    className="w-full px-4 py-2 border-b border-dashed border-gray-300  rounded-md bg-slate-100"
                                                    onChange={(e) => {
                                                        setFieldValue("branchName", e.target.value);
                                                    }}
                                                    readOnly
                                                />
                                            </div>
                                            <div>
                                                <label className="block text-sm font-medium mb-2">City <span className="text-red-400">*</span></label>
                                                <Field
                                                    type="text"
                                                    name="city"
                                                    disabled={!!initialValues?.city}
                                                    placeholder="City Name"
                                                    className="w-full px-4 py-2 border-b border-dashed border-gray-300  rounded-md bg-slate-100"
                                                    onChange={(e) => {
                                                        setFieldValue("city", e.target.value);
                                                    }}
                                                    readOnly
                                                />
                                            </div>
                                            <div>
                                                <label className="block text-sm font-medium mb-2">State <span className="text-red-400">*</span></label>
                                                <Field
                                                    type="text"
                                                    name="state"
                                                    placeholder="State Name"
                                                    disabled={!!initialValues?.state}
                                                    className="w-full px-4 py-2 border-b border-dashed border-gray-300  rounded-md bg-slate-100"
                                                    onChange={(e) => {
                                                        setFieldValue("state", e.target.value);
                                                    }}
                                                    readOnly
                                                />
                                            </div>



                                            {/* Account Type Dropdown */}
                                            <div>
                                                <label className="block text-sm font-medium mb-2">Account Type <span className="text-red-400">*</span></label>
                                                <Select
                                                    options={accountTypeOptions}
                                                    name="accountType"
                                                    isDisabled={!!initialValues?.accountType}
                                                    className="basic-single"
                                                    styles={{
                                                        control: (base, state) => ({
                                                            ...base,
                                                            borderColor: state.isFocused ? '#d1d5db' : '#d1d5db',
                                                            '&:hover': { borderColor: '#64748B' },
                                                            boxShadow: state.isFocused ? '0 0 0 0px #000000' : 'none',
                                                            borderRadius: '0.375rem',
                                                        }),
                                                        singleValue: (base) => ({
                                                            ...base,
                                                            color: '#000000',
                                                            fontSize: '0.875rem',
                                                        }),
                                                        option: (base, state) => ({
                                                            ...base,
                                                            backgroundColor: state.isSelected ? '#cbd5e1' : state.isFocused ? '#cbd5e1' : 'white',
                                                            color: state.isSelected ? '#000000' : '#000000',
                                                            fontSize: '0.875rem',
                                                            '&:hover': {
                                                                backgroundColor: '#cbd5e1',
                                                                color: '#000000',
                                                                fontSize: '0.875rem',
                                                            }
                                                        }),
                                                        placeholder: (base) => ({
                                                            ...base,
                                                            fontSize: '14px',
                                                            color: '#A3AAB5',
                                                            fontSize: '0.875rem',
                                                        }),
                                                    }}
                                                    classNamePrefix="select"
                                                    placeholder="Select Account Type"
                                                    value={values?.accountType}  // Store selected object, not just value string
                                                    onChange={(selectedOption) => setFieldValue("accountType", selectedOption)} // Store whole object
                                                // value={values?.accountType || null}
                                                // onChange={(selectedOption) => setFieldValue("accountType", selectedOption)}
                                                />
                                                <ErrorMessage name="accountType" component="div" className="text-red-500 text-sm mt-2" />
                                            </div>
                                            {/* GST */}
                                            {/* <div>
                                                <label className="block text-sm font-medium mb-2">GST Number </label>
                                                <Field
                                                    type="text"
                                                    name="gstNumber"
                                                    disabled={!!initialValues?.gstNumber}
                                                    placeholder="Enter GST Number"
                                                    className="w-full px-4 py-2 border rounded-md"
                                                    onChange={(e) => {
                                                        setFieldValue("gstNumber", e.target.value);
                                                    }}
                                                />
                                                <ErrorMessage name="gstNumber" component="div" className="text-red-500 text-sm mt-2" />
                                            </div> */}


                                        </div>

                                        {/* Submit Button */}
                                        <div className="flex justify-center">
                                            <button
                                                type="submit"
                                                disabled={!!initialValues?.accountNumber && !!initialValues?.bankHolderName}
                                                className="px-12 text-sm py-2 cursor-pointer bg-slate-800 text-white font-semibold rounded-lg hover:bg-slate-900 flex items-center gap-3"
                                            >
                                                <span>Submit</span>
                                                {loading && <SpinLoader className="text-sm" />}
                                            </button>
                                        </div>

                                    </Form>
                                )}
                            </Formik>
                            {/* </div> */}
                        </div>
                    </div>
                </div>

            </div >
        </>
    );
};

export default SellerPrufDetails
